module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_8019.7d46f0c5.png";